import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { ThreeDots } from 'react-loader-spinner';
import Image from 'next/image';
import { ENDPOINTS, WEB_URL } from '@/config/endpoints';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { FormProvider } from '@/component/shared/contactForm/formContext';
import Head from 'next/head';
import { useRouter } from 'next/router';
import IMAGES from '@/public/assets/img';
import MexicoForm from '@/component/shared/mexicoForm/mexicoForm';
import CalendlyBadge from '@/component/shared/CalendlyBadge';
import { useDownloadStrip } from '@/layout/downloadStripContext';
import AOS from 'aos';
import DeviceChecker from "@/component/shared/deviceChecker";
import BreadCrumb from '@/component/shared/breadCrumb';
import esMX from '@/locales/blogs/esMX';
import enIN from '@/locales/blogs/enIN';
import enUS from '@/locales/blogs/enUS';
import DownloadApp from '@/component/shared/downloadApp';
import DownloadPdfPopup from '@/component/shared/downloadPdfPopup';
import { pushCleverTapEvent } from '@/component/shared/pushCleverTapEvent';
import { getCategoryLink } from '@/component/shared/blog/categoryLink';
import { generateBlogSchema } from '@/component/shared/blog/blogSchema';
import { blogBreadcrumbSchema } from '@/lib/blogBreadcrumSchema';
import { generateFaqSchema } from '@/component/shared/faqSchema';
import SocialShare from '@/component/shared/blog/socialShare';

const keywordsTracking = [
  "exim policy",
  "invoice discounting",
  "sblc vs lc",
  "shipping bill download",
  "types of factoring",
  "loans",
  "funding",
  "working capital",
  "invoice finance",
  "export finance",
  "buyer creditworthiness",
  "sblc", 
  "types of factoring in financial services", 
  "negotiable instruments", 
  "sblc full form"
];

const ContactFormStep1 = dynamic(() => import('@/component/shared/contactForm/contactFormStep1'), {
    loading: () => <p>Loading...</p>})
const ContactFormStep2 = dynamic(() => import('@/component/shared/contactForm/contactFormStep2'), {
      loading: () => <p>Loading...</p>})


const BlogDetail = ({recentPosts,post,paraUrl,h2Elements, faqBlogs}) => {
    // const router = useRouter;
    const pathName = WEB_URL+paraUrl;
    const pathName_es = WEB_URL+`/es-mx`+paraUrl
    const [showNextStep, setShowNextStep]= useState(false);
    const router = useRouter();
    const { locale } = router;
    const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
    const { downloadStrip } = useDownloadStrip();
   const pillerID = ENDPOINTS.WORDPRES_DOWNLOAD_PDF;
   const isPostPillerID = pillerID.some((item) => item.id === post.id);
   const bioRef = useRef(null);
   const authorData = post._embedded.author[0];
   const linkedInUrl = authorData.yoast_head_json.schema["@graph"][3].sameAs.find(url => url.includes('linkedin.com'));
   const authorProfileImage = authorData.yoast_head_json.schema["@graph"][3].sameAs[1] || '';
   const authorDesignation = authorData.yoast_head_json.schema["@graph"][3].sameAs[2] || '';
   const faqSchema = generateFaqSchema(faqBlogs);
   const readKey = locale === "es-mx" ? "Tiempo de lectura" : "Est. reading time";
   const readTime = post?.yoast_head_json?.twitter_misc?.[readKey];
   const minutes = readTime?.split(" ")[0];

   if (!post || !recentPosts) {
    return <div className='fixed inset-0 z-[9999] items-center flex bg-[rgba(255,255,255,0.8)]'>
    <div className='w-[100px] mx-auto h-[100px] justify-center flex'>
    <ThreeDots 
      height="80" 
      width="80" 
      radius="9"
      color="#032B5C" 
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClassName="m-auto"
      visible={true}
      />
      </div>
    </div>;
  }
  const showSteps=()=>{
      setShowNextStep(true)
  }
  const showFirstStep=()=>{
    setShowNextStep(false)
  }

  const dateFormat = (publishDate)=>{
    const dateString = new Date(publishDate);
    const options = { day:'numeric', year: 'numeric', month: 'short' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('en-US',options);
      return <span>{result}</span>
    }
    
  }
  const dateFormatSpanish = (publishDate)=>{
    const dateString = new Date(publishDate);
    const options = { day:'numeric', year: 'numeric', month: 'short' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('es-MX',options);
      return <span>{result}</span>
    }
    
  }
  const cleanedContent = post.content.rendered ? post.content.rendered
  .replace(/\[vc_row[^\]]*]/g, '') // Replace [vc_row]
  .replace(/\[vc_column[^\]]*]/g, '') // Replace [vc_column]
  .replace(/\[vc_single_image[^\]]*]/g, '') // Replace [vc_single_image]
  .replace(/\[vc_row_inner[^\]]*]/g, '') // Replace [vc_row_inner]
  .replace(/\[vc_column_inner[^\]]*]/g, '') // Replace [vc_column_inner]
  .replace(/\[vc_empty_space[^\]]*]/g, '') // Replace [vc_empty_space]
  .replace(/\[vc_raw_html[^\]]*]\[[^\]]*]/g, '') // Replace [vc_raw_html] along with its content
  .replace(/\[\/vc_column_text\]/g, '') // Replace [/vc_column_text]
  .replace(/\[\/vc_column_inner\]/g, '') // Replace [/vc_column_inner]
  .replace(/\[\/vc_row_inner\]/g, '') // Replace [/vc_row_inner]
  .replace(/\[\/vc_column\]/g, '') // Replace [/vc_column]
  .replace(/\[\/vc_row\]/g, '') // Replace [/vc_row]
  .replace(/\[vc_widget_sidebar[^\]]*]/g, '') // Replace [vc_widget_sidebar]
  .replace(/\[vc_custom_heading[^\]]*]/g, '')
  .replace(/\[vc_raw_html[^\]]*]\[[^\]]*]/g, '') // Remove [vc_raw_html] along with its content
  .replace(/\[vc_raw_html]JTVCc21hcnRfcG9zdF9zaG93JTIwaWQlM0QlMjIxMDAwNSUyMiU1RA==\[\/vc_raw_html]/g, ''): post.content.rendered ;

  const htmlString = post.yoast_head ?post.yoast_head :'';
  // Define a regular expression to match the og:description meta tag
  const regex = /<meta\s+property="og:description"\s+content="([^"]+)"\s*\/>/;
  // Use the regex to extract the content
  const match = htmlString.match(regex);
  // Extracted description
  const description = match ? match[1] : null;
  const title = post.yoast_head_json.og_title.replace(/\[:.*?\]/g, '');
  
  const truncateString=(str, maxLength)=> {
    if (str.length <= maxLength) {
      return str; // No truncation needed
    }
  
    // Truncate the string and append an ellipsis
    const truncatedString = str.slice(0, maxLength - 3) + '...';
    return truncatedString;
  }
  const truncatedTitle=(title)=>{
    const originalString = title;
    const maxLength = 50;
    return truncateString(originalString, maxLength);
  }

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const trackFinancingKeyword = () => {
    if (locale ==='en-in') {
        pushCleverTapEvent("Blog_Page_Finance_Keyword", { "PageName": 'Blog_Page' });
    }
  };
  const financingMatch = keywordsTracking.some(keyword => cleanedContent.toLowerCase().includes(keyword.toLowerCase()));

  useEffect(() => {
    const accordionTitles = document.querySelectorAll('.gutena-accordion-block__panel-title');
  
    accordionTitles.forEach((title) => {
      title.addEventListener('click', () => {
        const panel = title.parentElement;
        // Close all other panels
        const allPanels = document.querySelectorAll('.wp-block-gutena-accordion-panel');
        allPanels.forEach((p) => {
          if (p !== panel) {
            p.classList.remove('open');
          }
        });
        // Toggle the clicked panel
        panel.classList.toggle('open');
      });
    });
    // Cleanup event listeners on component unmount
    return () => {
      accordionTitles.forEach((title) => {
        title.removeEventListener('click', () => {
          const panel = title.parentElement;
          panel.classList.toggle('open');
        });
      });
    };
  }, []);

  useEffect(() => {
    if (financingMatch) {trackFinancingKeyword(); }
    const handleScroll = (event) => {
      const target = document.querySelector(event.target.getAttribute('href'));
      if (target) {
        event.preventDefault();
        const targetPosition = target.getBoundingClientRect().top;
        const scrollPosition = targetPosition + window.pageYOffset - 140;
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      }
    };
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach((link) => link.addEventListener('click', handleScroll));
    return () => {
      links.forEach((link) => link.removeEventListener('click', handleScroll));
    };
  }, [financingMatch]);

  // Heading Of Blog
  const blogContentRef = useRef(null);
  useEffect(() => {
    if (blogContentRef.current) {
      const h2Tags = blogContentRef.current.querySelectorAll('h2');
      h2Tags.forEach((h2, index) => {
        h2.id = `h2-${index}`;
      });
    }
  }, [cleanedContent]);
  const handleScrollToH2 = (index) => {
    const targetElement = document.getElementById(`h2-${index}`);
    if (targetElement) {
      const offset = 140;
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };
 
  useEffect(() => {
    if (locale === 'en-in') {
      pushCleverTapEvent("Blog_Page_Visited", {
        "PageName": 'Blog_Page',
      });
    }
  }, [router.asPath,locale]);

  const blogSchema = generateBlogSchema(post,locale,description,minutes);

  const breadcrumbSchema = blogBreadcrumbSchema({
      homeUrl: WEB_URL+`${locale == 'es-mx'? '/es-mx':''}`,
      blogUrl:locale == 'es-mx'? pathName_es:pathName,
      blogTitle:post.title.rendered,
      locale

    }); 
  const authorName = () =>{ 
    if (authorData.name === "admin") return null;
      return  <>
      <span className='font-medium text-black'>| {t.authorData.authorTitle}: </span>
        <Link href={`/author/${authorData.slug}`}><span className="text-anchor-blue cursor-pointer">{authorData.name}</span></Link>
    </>}

  return (
    <main className='mt-[100px]'>
      
      <Head>  
          <title>{title || post.title.rendered}</title>
          <meta name="description" content={description} />
          <meta property="og:title" content={title || post.title.rendered}/>
          <meta property="og:description" content={description} />
          <meta property="og:image" content={post._embedded['wp:featuredmedia'][0].source_url} />
          <meta name="robots" content="max-image-preview:large" />
          {/* <link rel="alternate" hrefLang="es" href={WEB_URL+'/es'+router.asPath}/>
            <link rel="alternate" hreflang="en" href={WEB_URL+router.asPath} /> */}
          {locale == 'es-mx'? 
          <meta property="og:url" content={pathName_es} />
          :<meta property="og:url" content={pathName} />
          }
          {locale == 'es-mx'? 
          <link rel="canonical" href={pathName_es} />:
          <link rel="canonical" href={pathName} />
          }
          <link rel='preload' href={post._embedded['wp:featuredmedia'][0].source_url} as="image" />

           <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(blogSchema)
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbSchema)
        }}
      />
      {faqBlogs.length > 0 &&
       <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqSchema),
          }}
        />}
        </Head>
    {post !=null &&
       <section className={`${downloadStrip ? 'py-2' : 'pt-9 pb-sp-small'} sm:pt-10`}>
        <BreadCrumb parentPage={'Blog'} parentSlug={'blogs'} page={post.title.rendered} />
       <div className='container  lg:px-3 px-3 xm:px-2 mt-2'>
           <div className="flex flex-wrap blogDetail">
              <div className='sm:pr-0 pr-4 md:w-full sm:w-full w-[62%]'>
                <p className='text-sm text-[#7b7b7b] mb-1 sm:pt-2 md:pt-10'>
                  <span className='font-medium text-black'>{locale == 'es-mx'?'Publicado':'Published'} : </span>
                  {locale == 'en-in' && dateFormat(post.date)} 
                  {locale == 'es-mx' && dateFormatSpanish(post.date)}, 
                  <span className='font-medium text-black'>{locale == 'es-mx'? 'Actualizado':'Updated'} : </span>
                  {locale == 'en-in' && dateFormat(post.modified)} {locale == 'es-mx' && dateFormatSpanish(post.modified)} {authorName()}</p>
                      <h1 className="text-heading2 sm:text-xl text-secondary font-semibold pb-3 break-words">{post.title.rendered}</h1>  
                      {isPostPillerID && <DownloadPdfPopup blogPostID={post.id}/>}              
                      {post._embedded && post._embedded['wp:featuredmedia'] && (
                            <div className="w-full h-96 sm:h-auto overflow-hidden relative mb-2 sm:mb-xsp">
                            <Image src={post._embedded['wp:featuredmedia'][0].source_url} fetchPriority="high" priority={true} alt={post.title.rendered} width={1280} height={720} className="w-full h-full object-fill rounded-md" />
                           </div>
                      )}
                   <div className='flex justify-between items-center'><div className='flex gap-xsp'>{post.page_view > 0 && <p className='flex gap-xsp items-center text-sm font-medium'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path></svg>{`${post.page_view} ${t.blogviewData.blogView}`} |</p>}
                   {minutes && <p className='text-sm font-medium'> {`${minutes} ${t.blogviewData.blogRead}`}</p>}</div>
                    <SocialShare url={locale == 'es-mx' ? pathName_es : pathName} title={post.title.rendered}/></div>
                      {/* Blog Post Heading */}
                    {h2Elements.length > 0 &&
                      <div className="text-sm px-2 py-1 font-bold text-secondary border border-[#aaa] rounded-md bg-[#F9F9F9]">
                       <h3>{locale == 'es-mx' ? 'En la publicación del blog' :  'In the Blog Post'}</h3>
                      <ul className="list-decimal ml-2">
                        {h2Elements.map((h2, index) => (
                          <li key={index}>
                            <Link
                              href="#"
                              onClick={(e) => { e.preventDefault();
                               handleScrollToH2(index);
                              }}
                              className="flex items-center text-sm text-brand pt-1 sm:pt-[7px] sm:mt-[-2px] pl-xsp font-medium bg-none sm:text-xs leading-4 sm:text-left"
                              dangerouslySetInnerHTML={{ __html: h2 }}
                            > 
                            </Link>
                          </li>
                        ))}
                      </ul>
                      </div>
                     }  
                      <div className='blog-content' ref={blogContentRef} dangerouslySetInnerHTML={{__html: cleanedContent}}></div>
                      {locale == 'en-in' && 
                      post._embedded && post._embedded['wp:term'] && (
                            <div className='mb-3'>
                              <div className='text-base font-semibold'>Learn More about:
                              {
                              post._embedded['wp:term'][0].map(category => (
                                category.name != 'Blog' &&
                                
                                <Link key={category.id} className='hover:underline text-brand after:content-[","] last:after:content-[""]' href={getCategoryLink(category)}> {category.name}</Link>
                                
                              ))}
                              </div>
                            </div>
                      )}
                        
                   
              </div>
              <div className={`${locale=='en-in'?'':'hidden' } w-[37%] md:w-full sm:w-full md:mt-4 sm:mt-4`}>
                    <div className={`lg:sticky xm:sticky ${downloadStrip ? 'lg:top-[70px]' : 'lg:top-[130px]'} xm:top-[100px]`}>
                    <div className='mb-1'>
                    <FormProvider>
                    {!showNextStep ?
                    <ContactFormStep1 showStep1={showSteps} />:
                      <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew" />
                    }
                    </FormProvider>
                    </div>
                    <CalendlyBadge PageMeetingURL />
                    </div>
                </div>
                {locale=='es-mx' &&
                <div className={`${locale=='es-mx'?'':'hidden' } w-[37%] md:w-full sm:w-full md:mt-4 sm:mt-4`}>
                    <div className='lg:sticky xm:sticky lg:top-[130px] xm:top-[100px]'>
                    <div className='mb-5'>
                   <MexicoForm />
                    </div>

                    </div>
                </div>
                }
            </div>
            {authorData.name !== "admin" &&
            <div className='bg-[#FFFFE0] border border-gray p-2 rounded-xl mt-2 mr-2 sm:mr-0' ref={bioRef}>
              <div className='flex gap-4 sm:flex-col items-center'>
              <div className='w-full flex flex-col items-center text-center'>
              <Image src={authorProfileImage} width={190} height={200} alt='author image' className='h-[200px] max-w-[190px]'/>
              <Link href={`/author/${authorData.slug}`} className="text-anchor-blue cursor-pointer mt-1 text-sm" rel="noopener noreferrer">{t.authorData.viewProfile}</Link></div>
              <div>
               <h3 className='text-lg font-medium sm:text-base'>{authorData.name}</h3>
              <p className='text-base2 font-medium text-black mt-xsp sm:text-sm flex items-center'>{authorDesignation} <Link href={linkedInUrl} className='mx-1' target="_blank" rel="noopener noreferrer">
              <Image className='w-3 h-3' src={IMAGES.FOOTER.linkedIn} alt='linkedin' />
               </Link></p>
              <p className='text-base text-baseBlack mt-xsp sm:text-sm'><span className='font-medium text-black'>{t.authorData.authorBioTitle}:</span> {authorData.description}</p>
              </div>
            </div>
            </div>}

            {recentPosts.length >= 2 && (
            <div className='pt-sp-big'>
                <h3 className='text-lg text-secondary font-normal py-1'>{locale == 'es-mx' ? 'Blogs relacionados' : 'Related Content'}</h3>
                <hr className='mb-2 border-brand'/>
                <ul className='pt-1 flex flex-wrap -mx-2'>
                  {recentPosts.map((relatedPost,i) => (
                    <div key={i} className='w-[25%] md:w-[50%] sm:w-full mb-3 block px-2'>
                      <div className='border border-[#E6E6E6] min-h-[320px]'>    
                        <Link href={WEB_URL+`${locale == 'es-mx'? '/es-mx/blogs/':'/blogs/'}${relatedPost.slug}`} key={relatedPost.id}>
                        <div>
                          <div className='w-full'>
                          {relatedPost._embedded && relatedPost._embedded['wp:featuredmedia'] && (
                              <Image loading='lazy' className='w-full md:h-[200px] sm:h-auto border-b-[1px] border-[#E6E6E6]' src={relatedPost._embedded['wp:featuredmedia'][0].source_url} alt={relatedPost.title.rendered} width={256} height={139} />
                          )}
                          </div>
                          <div className='date-div p-1'>
                          <p className='text-xs mb-2'>{locale=='es-mx'? dateFormatSpanish(relatedPost.date): dateFormat(relatedPost.date)}</p>
                          
                          <h4 className='text-sm text-secondary font-regular two-line-truncate min-h-[40px] break-word' dangerouslySetInnerHTML={{ __html: truncatedTitle(relatedPost.title.rendered) }}/>
                          </div>   
                        </div>       
                        </Link>
                        {relatedPost._embedded && relatedPost._embedded['wp:term'] && (
                          <div className='p-1 py-0 mb-2'>
                            {
                            relatedPost._embedded['wp:term'][0].map(category => (
                              category.name != 'Blog' && category.name != 'Spanish Blog' &&
                              <Link key={category.id} className='text-[12px] text-brand bg-[#ddd] rounded-md py-[3px] px-[5px] mr-1 hover:underline' href={WEB_URL + (locale == 'es-mx' ? '/es-mx/blogs/' : '/blogs/') + `category/${category.id}/${category.slug}`}>{toTitleCase(category.name)}</Link>
                            ))}
                          </div>
                        )}
                      </div>


                      </div>

                      
                  ))}

                  
                </ul>
            </div>
            )}
       </div>
   </section>
    } 
 </main>
  );
};

export default BlogDetail;


export async function getServerSideProps(context) {
  // Fetch data from an API or database
  const { req, locale,res } = context;
  const paraUrl = context.resolvedUrl || null;
  let paramSlug = ''
  // if (locale == 'es-mx') {
    paramSlug = paraUrl.replace(/^\/blogs\//, '');
  // }else{
  //   paramSlug = paraUrl.replace(/^\/blogs\//, '');
  // }
  let postId = '';
  let postData = '';
  let recentPostData = '';
  let postCategory =[];
  let relatedCat = '';
  try {
    const response = await fetch(ENDPOINTS.WORDPRESS_MAIN_API+`?_embed&slug=${paramSlug}${locale == 'es-mx'? `&lang=es`:''}`); // Replace with your WordPress API endpoint URL
    const data = await response.json();
    if (data.length > 0) {
      postId = data[0].id;
    } else{
      res.statusCode = 404;
      return{
        notFound: true,
      }
    }
  } catch (error) {
    console.error('Error:', error);
    res.statusCode = 500;
    return {
      notFound: true,
    };
  }
  if (postId) {
    try {
      const response = await fetch(ENDPOINTS.WORDPRESS_MAIN_API + `/${postId}?_embed${locale == 'es-mx' ? `&lang=es` : ''}`);
      const data = await response.json();
      postData = data;
      postCategory = postData._embedded['wp:term'][0];
      relatedCat = postCategory.filter(category => category.slug !== 'blog');
    } catch (error) {
      console.error('Error:', error);
      res.statusCode = 500;
      return {
        notFound: true,
      };
    }
    const tryFetchRecentPosts = async (perPage) => {
      try {
        const res = await axios.get(ENDPOINTS.WORDPRESS_MAIN_API + `?&categories=${relatedCat[0].id}&per_page=${perPage}&_embed${locale == 'es-mx' ? `&lang=es` : ''}`);
        return res.data;
      } catch (error) {
        console.error(`Error fetching related posts with perPage=${perPage}:`, error);
        return null;
      }
    };
    let recentPostsData = null;
    let perPageOptions = [5, 4, 3];
    for (let perPage of perPageOptions) {
      recentPostsData = await tryFetchRecentPosts(perPage);
      if (recentPostsData && recentPostsData.length > 1) {
        recentPostData = recentPostsData.filter((post) => post.slug !== paramSlug)
        .slice(0, 4);
        break;
      }
    }
    if (!recentPostData || recentPostData.length === 0) {
      recentPostData = [];
    }
  }
  // H2 Elements
   const h2Data = postData.content.rendered ? postData?.content?.rendered : "";
   const h2Elements = [];
   const regex = /<h2[^>]*>(.*?)<\/h2>/g;
   let match;
   while ((match = regex.exec(h2Data)) !== null) {
    const cleanText = match[1].replace(/<\/?strong>/g, ""); 
    h2Elements.push(cleanText);
   }
  // Find the FAQ and Answer
  const faqMatch = h2Data.match(
    /<h2[^>]*>(?:\s|<[^>]+>|&nbsp;)*(FAQs|FAQs-|Frequently Asked\s*Questions|Preguntas(?:\s|&nbsp;)*Frecuentes)(?:\s|<[^>]+>|&nbsp;)*<\/h2>([\s\S]*)/i
  );
  const faqBlogs = faqMatch
    ? [...faqMatch[2].matchAll(/<(p|li)[^>]*>(.*?)<\/\1>/gi)]
        .map(([, tag, text]) => ({
          tag,
          text: text
            .replace(/<[^>]*>/g, "")
            .replace(/&#8211;|–/g, "-")
            .trim(),
        }))
        .filter(item => item.text)
        .reduce((acc, item, index, arr) => {
          const isQuestion =
            item.tag === "li" ||
            /^Q\d+:/i.test(item.text) ||
            item.text.includes("?");
  
          if (isQuestion) {
            acc.push({
              question: item.text,
              answers: arr[index + 1]?.text || "",
            });
          }
          return acc;
        }, [])
    : [];
  // Return the data as props
  return {
    props: {
      post:postData,
      recentPosts:recentPostData,
      paraUrl,
      h2Elements,
      faqBlogs,
    },
  };
}